// npm
import React from 'react'
import PropTypes from 'prop-types'

// material-ui
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import withStyles from '@material-ui/core/styles/withStyles'

// icons
import Create from '@material-ui/icons/Create'
import CropSquare from '@material-ui/icons/CropSquare'
import RadioButtonUnchecked from '@material-ui/icons/RadioButtonUnchecked'
import Remove from '@material-ui/icons/Remove'
import TrendingFlat from '@material-ui/icons/TrendingFlat'
import TextFields from '@material-ui/icons/TextFields'
import NearMe from '@material-ui/icons/NearMe'
import GridOn from '@material-ui/icons/GridOn'
import GridOff from '@material-ui/icons/GridOff'
import Undo from '@material-ui/icons/Undo'
import Delete from '@material-ui/icons/Delete'
import DeleteSweep from '@material-ui/icons/DeleteSweep'

// constants
import {TOOLS} from './constants'


const TOOL_BUTTONS = [
	{tool: TOOLS.SELECT, Icon: NearMe, label: 'Select'},
	{tool: TOOLS.PEN, Icon: Create, label: 'Pen'},
	{tool: TOOLS.RECT, Icon: CropSquare, label: 'Rectangle'},
	{tool: TOOLS.DIAMOND, Icon: CropSquare, label: 'Diamond', rotate: 45},
	{tool: TOOLS.CIRCLE, Icon: RadioButtonUnchecked, label: 'Circle'},
	{tool: TOOLS.LINE, Icon: Remove, label: 'Line', rotate: -45},
	{tool: TOOLS.ARROW, Icon: TrendingFlat, label: 'Arrow'},
	{tool: TOOLS.TEXT, Icon: TextFields, label: 'Text label'}
];

let Toolbar = ({
	classes, activeTool, onSelectTool, showGrid, onToggleGrid, onUndo, canUndo,
	onClear, hasSelection, onDeleteSelected
}) => (
	<div className={classes.toolbar}>
		{TOOL_BUTTONS.map(({tool, Icon, label, rotate}) => (
			<Tooltip title={label} key={tool}>
				<IconButton onClick={() => onSelectTool(tool)} className={classes.button}>
					<Icon
						className={activeTool === tool ? classes.active : classes.inactive}
						style={rotate ? {transform: `rotate(${rotate}deg)`} : undefined}
					/>
				</IconButton>
			</Tooltip>
		))}

		<span className={classes.divider}/>

		<Tooltip title={showGrid ? 'Hide grid' : 'Show grid'}>
			<IconButton onClick={onToggleGrid} className={classes.button}>
				{showGrid
					? <GridOn className={classes.active}/>
					: <GridOff className={classes.inactive}/>}
			</IconButton>
		</Tooltip>

		<Tooltip title="Delete selected shape">
			<span>
				<IconButton onClick={onDeleteSelected} className={classes.button} disabled={!hasSelection}>
					<Delete className={classes.inactive}/>
				</IconButton>
			</span>
		</Tooltip>

		<Tooltip title="Undo last shape">
			<span>
				<IconButton onClick={onUndo} className={classes.button} disabled={!canUndo}>
					<Undo className={classes.inactive}/>
				</IconButton>
			</span>
		</Tooltip>

		<Tooltip title="Clear all">
			<IconButton onClick={onClear} className={classes.button}>
				<DeleteSweep className={classes.inactive}/>
			</IconButton>
		</Tooltip>
	</div>
);

Toolbar.propTypes = {
	activeTool: PropTypes.string.isRequired,
	onSelectTool: PropTypes.func.isRequired,
	showGrid: PropTypes.bool.isRequired,
	onToggleGrid: PropTypes.func.isRequired,
	onUndo: PropTypes.func.isRequired,
	canUndo: PropTypes.bool.isRequired,
	onClear: PropTypes.func.isRequired,
	hasSelection: PropTypes.bool.isRequired,
	onDeleteSelected: PropTypes.func.isRequired
};

const styles = ({palette, spacing}) => ({
	toolbar: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center',
		borderBottom: `1px solid ${palette.background.contrastText}`,
		paddingBottom: spacing.unit / 2,
		marginBottom: spacing.unit
	},
	button: {
		padding: spacing.unit / 2
	},
	active: {color: palette.primary.main},
	inactive: {color: palette.background.contrastText},
	divider: {
		width: 1,
		alignSelf: 'stretch',
		backgroundColor: palette.background.contrastText,
		margin: `0 ${spacing.unit}px`
	}
});

Toolbar = withStyles(styles)(Toolbar);

export {Toolbar}
